import React from "react";
import {p0, p1, p2, p4, p8, p16, p32} from "../../pl_commons";
import PlIcon from "../pl_icon";


const SbIcon = ({item}) => {

    var svgitems = [];

    svgitems.push(<circle key={"c1yy"} cx={p2} cy={p2} r={p1} stroke= {"#464646"} strokeWidth="1" fill={"#adadad"}/>)

    console.log("HALLO HALLO **************")

    return(
        <PlIcon item={item}>
            {svgitems}
        </PlIcon>
    )

}

export default SbIcon
